__webpack_require__.p = "/tokens-one-navigation/referrals-hub/";